import type { ChatMentionsMenuItemType } from '@terra/ui-design-system';
import type { InteractMentionData } from '@terra/shared-dto-chat-types';
import type { Interaction } from '@terra/shared-contracts-interact';
import { createElement } from 'react';
import { Globe02Icon } from '@terra/ui-icons';

function formatInteractRawText({
  interaction,
  domain,
}: {
  interaction: Interaction;
  domain: string;
}): string {
  const lines: string[] = [];

  lines.push(`=== ${interaction.protocol.toUpperCase()} Interaction ===`);
  lines.push(`Domain: ${domain}`);
  lines.push(`Timestamp: ${interaction.timestamp}`);
  lines.push(`Remote Address: ${interaction.remoteAddress}`);
  lines.push(`Unique ID: ${interaction.uniqueId}`);
  if (interaction.qType) {
    lines.push(`Query Type: ${interaction.qType}`);
  }

  if (interaction.httpMethod) {
    lines.push(`HTTP Method: ${interaction.httpMethod}`);
  }

  if (interaction.httpPath) {
    lines.push(`HTTP Path: ${interaction.httpPath}`);
  }

  if (
    interaction.httpHeaders &&
    Object.keys(interaction.httpHeaders).length > 0
  ) {
    lines.push('');
    lines.push('--- HTTP Headers ---');
    for (const [key, value] of Object.entries(interaction.httpHeaders)) {
      lines.push(`${key}: ${value}`);
    }
  }

  if (interaction.httpBody) {
    lines.push('');
    lines.push('--- HTTP Body ---');
    lines.push(interaction.httpBody);
  }

  if (interaction.rawRequest) {
    lines.push('');
    lines.push('--- Raw Request ---');
    lines.push(interaction.rawRequest);
  }

  if (interaction.rawResponse) {
    lines.push('');
    lines.push('--- Raw Response ---');
    lines.push(interaction.rawResponse);
  }

  return lines.join('\n');
}

export function createInteractMention({
  interaction,
  sessionId,
  domain,
}: {
  interaction: Interaction;
  sessionId: string;
  domain: string;
}): ChatMentionsMenuItemType {
  const rawText = formatInteractRawText({ interaction, domain });
  const label = `${interaction.protocol.toUpperCase()} from ${interaction.remoteAddress}`;
  const interactData: InteractMentionData = {
    sessionId,
    interactionId: interaction.id,
    protocol: interaction.protocol,
    domain,
    timestamp: interaction.timestamp,
    remoteAddress: interaction.remoteAddress,
    qType: interaction.qType,
    httpMethod: interaction.httpMethod,
    httpPath: interaction.httpPath,
    httpHeaders: interaction.httpHeaders,
    httpBody: interaction.httpBody,
    rawRequest: interaction.rawRequest,
    rawResponse: interaction.rawResponse,
    rawText,
  };

  return {
    id: `interact-${sessionId}-${interaction.id}`,
    label,
    icon: createElement(Globe02Icon, { size: 12 }),
    type: 'child',
    mentionEntity: {
      entityType: 'Interact',
      entityId: interaction.id,
      label,
      extraData: { interact: interactData },
    },
  };
}
